import React, { useState } from "react";
import { Table } from "antd";

import ProcedureDropdown from "./ProcedureDropdown";

// This table is not for procedures
export default function PredeterminationProceduresTable({
  insurances,
  allProcedures,
  approvedPatients,
  currentPatientID,
  approvedProcedures,
  disabledByApproved,
  setMarkedProcedures,
  setApprovedProcedures,
  emptyProcedureDropdowns,
  setEmptyProcedureDropdown,
  predeterminationOrPostPayment,
}) {
  const [isSettingProcedureCode, setIsSettingProcedureCode] = useState(false); // Loading for the time that insurance patient is changed

  // Predetermination Columns: Procedures, Tooth/Quad, Estimated Cost, Insurance Estiamte, Discount, Patient Responsibility
  // Post Payment Columns: Extracted Procedures, Related Procedure, Tooth/Quad, Estimated Cost, Eligible Amount, Paid Amount, Claim Date
  const proceduresColumns = [
    {
      title: `${predeterminationOrPostPayment === "post-paymment" ? "Extracted" : ""} Procedures`,
      dataIndex: "procedure_code",
      key: "procedure_code",
      render: (code, record) => `${record.temp_procedure_code} ${record.temp_procedure_des ? `- ${record.temp_procedure_des}` : ""}` || "-",
    },
    {
      title: "Related Procedure",
      dataIndex: "procedure_code",
      width: 260,
      key: "procedure_code",
      hidden: predeterminationOrPostPayment === "predetermination",
      render: (_, record) => (
        <ProcedureDropdown
          insurances={insurances}
          currentProcedure={record}
          allProcedures={allProcedures}
          approvedPatients={approvedPatients}
          currentPatientID={currentPatientID}
          numberOfInsurances={insurances.length}
          approvedProcedures={approvedProcedures}
          disabledByApproved={disabledByApproved}
          setApprovedProcedures={setApprovedProcedures}
          isSettingProcedureCode={isSettingProcedureCode}
          emptyProcedureDropdowns={emptyProcedureDropdowns}
          setIsSettingProcedureCode={setIsSettingProcedureCode}
          setEmptyProcedureDropdown={setEmptyProcedureDropdown}
        />
      ),
    },
    {
      title: "Tooth/Quad",
      dataIndex: "tooth",
      key: "tooth",
      render: (tooth) => tooth || "-",
    },
    {
      title: "Estimate Cost",
      dataIndex: "estimated_cost",
      key: "estimated_cost",
      render: (estimate) => (estimate ? `$${parseFloat(estimate).toFixed(2)}` : "-"),
    },
    {
      title: "Insurance Estimate",
      dataIndex: "insurance_estimate",
      key: "insurance_estimate",
      hidden: predeterminationOrPostPayment === "post-payment",
      render: (amount) => (amount ? `$${parseFloat(amount).toFixed(2)}` : "-"),
    },
    {
      title: "Discount",
      dataIndex: "discount",
      key: "discount",
      hidden: predeterminationOrPostPayment === "post-payment",
      render: (amount) => (amount ? `$${parseFloat(amount).toFixed(2)}` : "-"),
    },
    {
      title: "Patient Responsibility",
      dataIndex: "patient_responsibility",
      key: "patient_responsibility",
      hidden: predeterminationOrPostPayment === "post-payment",
      render: (amount) => (amount ? `$${parseFloat(amount).toFixed(2)}` : "-"),
    },
    {
      title: "Paid Amount",
      dataIndex: "paid_amount",
      key: "paid_amount",
      hidden: predeterminationOrPostPayment === "predetermination",
      render: (amount) => (amount ? `$${parseFloat(amount).toFixed(2)}` : "-"),
    },
    {
      title: "Claim Date",
      dataIndex: "claim_date",
      key: "claim_date",
      hidden: predeterminationOrPostPayment === "predetermination",
      render: (date) => (date ? new Date(date).toLocaleDateString() : "-"),
    },
  ];

  return (
    <Table
      dataSource={insurances}
      columns={proceduresColumns}
      rowKey="id"
      pagination={false}
      rowSelection={
        predeterminationOrPostPayment === "predetermination"
          ? { type: "checkbox", onChange: (newSelectedProcedures) => setMarkedProcedures(newSelectedProcedures) }
          : null
      }
    />
  );
}
